<!--
 * @Author: WGL
 * @Date: 2023-06-21 09:23:33
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-18 10:20:36
 * @Description: 
-->
<template>
  <div class="ptb5 abs_rt fx" style="z-index: 1000">
    <div v-for="(item, index) in tagList" :key="index">
      <template v-if="item.show">
        <el-tooltip
          :content="t(item?.tips)"
          effect="dark"
          :persistent="false"
          placement="top"
        >
          <div class="wh20 fxmc cp r100px cf mr2 b" :class="item.class">
            <jwt-icon v-if="item.icon" :icon="item.icon" />
            <span v-else>{{ item?.title }}</span>
          </div>
        </el-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
  // 基础产品编码组件
  import { defineComponent, reactive, toRefs, computed } from 'vue'
  import { t } from '@/utils/i18n'

  export default defineComponent({
    name: 'BaseProductStatusTag',
    components: {},
    props: {
      info: { type: Object, default: () => {} },
    },
    setup(props) {
      const state = reactive({})
      const tagList = computed(() => {
        return [
          {
            title: 'P',
            tips: '计划开发产品',
            show: props?.info?.status === 0,
            class: 'bgd',
          },
          {
            title: 'D',
            tips: '开发中产品',
            show: props?.info?.status === 5,
            class: 'bgt',
          },
          {
            title: 'N',
            tips: '新产品',
            show: props?.info?.status === 10,
            class: 'bgy',
          },
        ]
      })

      return {
        tagList,
        ...toRefs(state),
        t,
      }
    },
  })
</script>

<style lang="scss" scoped></style>
